import { Component, OnInit, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { AdminService, DashboardData } from '../../services/admin.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, AfterViewInit {
  animatedStats = {
    familyMembers: 0,
    connections: 0,
    generations: 0,
    recentUpdates: 0
  };

  dashboardData: DashboardData | null = null;
  isLoading = true;
  error: string | null = null;

  constructor(
    public authService: AuthService,
    private adminService: AdminService
  ) {}

  ngOnInit(): void {
    this.loadDashboardData();
  }

  ngAfterViewInit(): void {
    // Animation will be triggered after data is loaded
  }

  private loadDashboardData(): void {
    this.isLoading = true;
    this.error = null;

    this.adminService.getDashboardData().subscribe({
      next: (data: any) => {
        if(data && data.data){
          console.log('📊 Dashboard - API Data received:', data);
          this.dashboardData = data.data;
          this.isLoading = false;
        
          // Update target stats with real data
          this.animateStatsWithRealData(data.data);
        }
      },
      error: (error) => {
        console.error('📊 Dashboard - Error loading data:', error);
        this.error = 'Failed to load dashboard data. Please try again.';
        this.isLoading = false;
        
        // Fallback to default values
        this.animateStats();
      }
    });
  }

  private animateStatsWithRealData(data: DashboardData): void {
    const targetStats = {
      familyMembers: data.totalRelatives,
      connections: data.activeRelatives,
      generations: Math.max(1, Math.floor(data.totalRelatives / 4)), // Estimate generations
      recentUpdates: data.recentSignups
    };

    console.log('📊 Dashboard - Animating with real data:', targetStats);
    this.animateStats(targetStats);
  }

  private animateStats(targetStats?: {
    familyMembers: number;
    connections: number;
    generations: number;
    recentUpdates: number;
  }): void {
    const stats = targetStats || {
      familyMembers: 1,
      connections: 0,
      generations: 1,
      recentUpdates: 0
    };

    const duration = 2000; // 2 seconds
    const steps = 60;
    const stepDuration = duration / steps;

    Object.keys(stats).forEach((key, index) => {
      const target = stats[key as keyof typeof stats];
      const start = 0;
      const increment = target / steps;
      
      let current = start;
      const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
          current = target;
          clearInterval(timer);
        }
        this.animatedStats[key as keyof typeof this.animatedStats] = Math.floor(current);
      }, stepDuration + (index * 100)); // Stagger animations
    });
  }

  getCurrentUserId(): number | null {
    const currentUser = this.authService.getCurrentUser();
    return currentUser ? currentUser.id : null;
  }
}
